import script from "./ShowClient.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowClient.vue?vue&type=script&setup=true&lang=js"

import "./ShowClient.vue?vue&type=style&index=0&id=2fd47c2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd47c2e"]])

export default __exports__